export default function () {
  const hamburgerButtonSelector = '[data-js-hamburger]'
  const hamburgerButton = document.querySelector(hamburgerButtonSelector)
  const body = document.body

  const disabledContentXsClass = 'is--disabled-xs'

  hamburgerButton?.addEventListener('click', () => {
    const expanded = hamburgerButton.getAttribute('aria-expanded') === 'true' || false
    hamburgerButton.setAttribute('aria-expanded', !expanded)
    body.classList.toggle(disabledContentXsClass, !expanded)
  })

  const settings = {
    selectors: {
      anchorNav: '[data-js-sticky-inpage-nav]',
      link: '[data-js-sticky-inpage-link]',
      list: '[data-js-sticky-inpage-list]'
    },
    classes: {
      isActive: 'active',
      isSticky: 'is-sticky'
    }
  }

  const anchorNavigations = document.querySelectorAll(settings.selectors.anchorNav)

  window.addEventListener('scroll', () => {
    anchorNavigations.forEach(anchorNavigation => {
      const elementsInFocus = []
      let lastElementEnd = 0
      const targets = []
      const links = anchorNavigation.querySelectorAll(settings.selectors.link)

      const stickyTop = parseInt(window.getComputedStyle(anchorNavigation).top)
      const currentTop = anchorNavigation.getBoundingClientRect().top
      const tolerance = 2

      anchorNavigation.classList.toggle(
        settings.classes.isSticky,
        currentTop <= stickyTop + tolerance
      )

      links.forEach((link) => {
        const url = new URL(link.href)
        const target = document.querySelector(url.hash)

        if (target === null) {
          return
        }

        targets.push(target)
      })

      targets.forEach(target => {
        const offset = target.getBoundingClientRect()
        const elementStart = offset.top
        const elementEnd = elementStart + offset.height
        const screenStart = window.innerHeight * 0.1
        const screenEnd = window.innerHeight * 0.35
        let filledStart, filledEnd

        if (lastElementEnd < elementEnd) {
          lastElementEnd = elementEnd
        }

        if (elementStart < screenEnd && elementEnd > screenStart) {
          if (elementEnd > screenEnd) {
            filledEnd = screenEnd
          } else {
            filledEnd = elementEnd
          }

          if (elementStart > screenStart) {
            filledStart = elementStart
          } else {
            filledStart = screenStart
          }

          elementsInFocus.push({
            elem: target,
            filled: filledEnd - filledStart
          })
        }
      })

      elementsInFocus.sort((a, b) => b.filled - a.filled)

      links.forEach((link) => {
        if (
          elementsInFocus.length > 0 &&
          link.getAttribute('href') === `#${elementsInFocus[0].elem.getAttribute('id')}`
        ) {
          if (!link.classList.contains(settings.classes.isActive)) {
            link.classList.add(settings.classes.isActive)
          }
        } else {
          link.classList.remove(settings.classes.isActive)
        }
      })
    })
  }, {
    passive: true
  })
}
